'use client';

import { color } from '@ahamove/tokens';
import { useAuth } from '@ahm/react-auth';
import { useLocationStore } from '@ahm/react-map/store';
import { rem } from '@mantine/core';
import { useEffect } from 'react';
import { BaseAddressAutocomplete } from './autocomplete';
import { useGetUserPlace } from './form/use-get-user-place';
import { SavedAddressOptions } from './options';
import type { AddressAutocompleteProps } from './types';

export function AddressAutocomplete({
  withSavedPlace,
  ...props
}: AddressAutocompleteProps) {
  const setSavedLocations = useLocationStore.use.setSavedLocations();
  const { status } = useAuth();

  const { data: result, isSuccess } = useGetUserPlace({
    enabled: withSavedPlace && status === 'authenticated',
  });

  useEffect(() => {
    if (isSuccess) {
      setSavedLocations(result);
    }
  }, [isSuccess, result, setSavedLocations]);

  return (
    <BaseAddressAutocomplete
      savedPlaceSlots={
        withSavedPlace ? (
          <SavedAddressOptions pathIndex={props.pathIndex} />
        ) : undefined
      }
      inputStyles={{
        input: {
          height: rem(48),
          whiteSpace: 'nowrap',
          overflowX: 'hidden',
          textOverflow: 'ellipsis',
          color: color.neutral[70],
          fontWeight: 700,
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
          borderRadius: 0,
          backgroundColor: 'white',
        },
        section: { height: rem(48) },
      }}
      {...props}
    ></BaseAddressAutocomplete>
  );
}
